import { CiCircleRemove } from "react-icons/ci";

import Grid from "@Components/Grid";
import Select from "@Components/Select";
import IconButton from "@Components/IconButton";
import { FilterPreviewProps } from "@Components/Filters/types";

type StatusFilterProps = FilterPreviewProps & {
  activeValue?: string;
  onSelect?: (value?: string) => void;
};

// Single-select dropdown for a column filter that is driven by state owned
// outside the Table (e.g. shared with the status cards above the table), so
// only one status can ever be active at a time.
const StatusFilter = ({
  placeholder,
  valuesForSelect,
  activeValue,
  onSelect,
}: StatusFilterProps) => {
  const activeLabel = valuesForSelect?.find(
    (option) => option.value === activeValue
  )?.label;

  return (
    <Grid container xs={12}>
      {activeLabel && (
        <Grid xs={12}>
          <IconButton
            onClick={() => onSelect?.(undefined)}
            flex
            style={{ fontSize: "16px" }}
          >
            {activeLabel}
            <CiCircleRemove size={18} />
          </IconButton>
        </Grid>
      )}
      <Select
        name={placeholder}
        placeholder={placeholder}
        value={activeValue ?? ""}
        onChange={(e) => onSelect?.(e.target.value || undefined)}
        options={valuesForSelect}
      />
    </Grid>
  );
};

export default StatusFilter;
